<template>
  <b-tab v-if="analysis_collection" lazy :title="sample_type.name">
    <b-card-text>
      <b-form-group class="mb-0" :horizontal="false">
        <div class="row">
          <div
            class="col-md-6"
            v-for="(option, index) in analysis_collection.models"
            :key="index"
          >
            <b-form-checkbox
              :key="option.id"
              :value="option.id"
              v-model="checked"
              :name="option.id"
              inline
            >
              <strong>{{ option.getAnalyte().name }}</strong
              >: {{ option.name }}
              <b-badge
                v-if="option.modus_name"
                v-b-tooltip.hover
                title="MODUS nomenclature"
                variant="light"
                class="ml-1 mr-1 text-muted"
                pill
              >
                <i class="fa fa-leaf" /> {{ option.modus_name }}
              </b-badge>
              <b-badge
                v-if="option.measurement_method"
                v-b-tooltip.hover
                title="Measurement method"
                variant="light"
                class="ml-1 mr-1 text-muted"
                pill
              >
                <i class="fa fa-ruler" /> {{ option.measurement_method }}
              </b-badge>
              <b-badge
                v-if="option.extraction_method"
                v-b-tooltip.hover
                title="Extraction method"
                variant="light"
                class="ml-1 mr-1 text-muted"
                pill
              >
                <i class="fa fa-eye-dropper" /> {{ option.extraction_method }}
              </b-badge>
            </b-form-checkbox>
          </div>
        </div>
      </b-form-group>
    </b-card-text>
  </b-tab>
</template>

<script>
import InstrumentModel from "@/models/lab/InstrumentModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "InstrumentFormAnalysisCardstackCard",
  props: {
    instrument: {
      type: Object,
      default: () => new InstrumentModel(),
    },
    sample_type: {
      type: Object,
      default: () => new SampleTypeModel(),
    },
    instrument_tests: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    checked: {
      get() {
        return this.instrument_tests;
      },
      set(value) {
        this.$emit("instrumentAnalysisClick", value);
      },
    },
  },
  data() {
    return {
      analysis_collection: null,
    };
  },
  async created() {
    this.analysis_collection = await getCollection({
      collection_type: "analysis",
      filters: [
        {
          logic: this.sample_type.id ? "filterEquals" : "filterNull",
          field: "analyte.sample_type_id",
          value: this.sample_type.id ? this.sample_type.id : null,
        },
      ],
      sort: [
        {
          logic: "sortAddAsc",
          field: "analyte.name",
        },
        {
          logic: "sortAddAsc",
          field: "name",
        },
      ],
      limit: "all",
    });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
